import { ArticleHeading3, ArticleParagraph1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './NewbuildingFlatBooking.css';
import { BookingDetails } from './parts/BookingDetails';

interface IBookingDetail {
  label: string;
  text: string;
}

export interface INewbuildingFlatBookingProps {
  bookingButton?: React.ReactNode;
  bookingLink: React.ReactNode;
  details?: IBookingDetail[] | null;
}

export const NewbuildingFlatBooking: React.FC<INewbuildingFlatBookingProps> = ({
  bookingButton,
  bookingLink,
  details,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        <div className={styles['title']}>
          <ArticleHeading3 as="h3">Забронируйте квартиру на Циан</ArticleHeading3>
        </div>
        <div className={styles['description']}>
          <ArticleParagraph1>Зафиксируйте стоимость и спокойно занимайтесь оформлением</ArticleParagraph1>
        </div>
        {details && details.length > 0 && <BookingDetails details={details} />}
        <div className={styles['buttons']}>
          {bookingButton && <div className={styles['button']}>{bookingButton}</div>}
          <div className={styles['button']}>{bookingLink}</div>
        </div>
      </div>
    </div>
  );
};
